import NombreArtista from "../../../components/NombreArtista";
import RosterPublico from "../../../components/RosterPublico";
import {
  Box,
  Button,
  Chip,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import useApi from "../../../hooks/useApi";
import { useEffect, useState } from "react";
import GlobalHeader from "../../../components/GlobalHeader";
import SnackAlert from "../../../components/SnackAlert";
import useSnack from "../../../hooks/useSnack";
import { LoadingButton } from "@mui/lab";
import { Link as RouterLink, useParams, useSearchParams } from "react-router-dom";
import { Audio } from "react-loading-icons";
import countries from "../../../utils/countries";
import ModalView from "../envios/modal";
import {
  FaSpotify,
  FaTiktok,
  FaInstagram,
  FaYoutube,
  FaFacebook,
} from "react-icons/fa";
import { hrefSeguro } from "../../../utils/hrefSeguro";
import { urlsDelPost } from "../../../utils/urlsPost";

const socialNetwork = [
  { name: "facebook", Icon: FaFacebook },
  { name: "instagram", Icon: FaInstagram },
  { name: "youtube", Icon: FaYoutube },
  { name: "spotify", Icon: FaSpotify },
  { name: "tiktok", Icon: FaTiktok },
];

const STATUS_LABELS = {
  pending: { label: "Pendiente", color: "warning" },
  approve: { label: "Aprobado", color: "success" },
  rejected: { label: "Rechazado", color: "error" },
};

export default function VistaCancionProductor() {
  const { loadApi, loadingApi } = useApi();
  const { songId } = useParams();
  // Desde el historial llega el envío que se abrió: puede haber varios de la
  // misma canción (un reenvío u otro tipo de envío).
  const [searchParams] = useSearchParams();
  const envioId = searchParams.get("envio");
  const [mainData, setMainData] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const { msgSB, openSB, showSnack, typeSB } = useSnack();

  useEffect(() => {
    loadApi(
      `productor/canciones/${songId}${envioId ? `?envio=${encodeURIComponent(envioId)}` : ""}`,
      true,
      "get"
    )
      .then((response) => {
        setMainData(response.data || false);
      })
      .catch((e) => {
        showSnack(e.message, "error", false);
      });
  }, []);

  function updateSend(status) {
    setOpenDialog({
      status,
      // El id del ENVÍO: la ruta de aprobación ya no va por songId.
      id: mainData.envioId,
      url: mainData.url,
      preview: {
        cover: mainData.url_img,
        cancion: mainData.nombre,
        artista: mainData.artista?.nombre || mainData.profile?.nombre_media,
        redes: mainData.artista?.redes,
        radarCoin: mainData.radarCoin,
      },
    });
  }

  function loadDecision(id, form) {
    loadApi(`productor/envios/${id}`, true, "put", form)
      .then((response) => {
        showSnack(response.data.message);
        setOpenDialog(false);
        setMainData((aData) => ({
          ...aData,
          status: form.status,
          feedback: form.feedback || aData.feedback,
          urls_post: form.urls_post || aData.urls_post,
        }));
      })
      .catch((error) => {
        showSnack(error.message, "error");
      });
  }

  const statusInfo = STATUS_LABELS[mainData.status] || null;

  return (
    <>
      <GlobalHeader />
      {!mainData ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100vw",
            height: `calc(100vh - ${
              window.document.getElementById("GlobalHeader")?.offsetHeight ||
              "64"
            }px - 32px)`,
          }}
        >
          <Audio fill="#F27224" />
        </Box>
      ) : (
        <Container>
          <Grid container spacing={2} mb={5}>
            {/* COLUMNA IZQUIERDA */}
            <Grid item xs={12} md={7} lg={7}>
              <Stack spacing={2}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{
                    paddingBottom: 1,
                    borderBottom: "2px solid gray",
                  }}
                >
                  <Typography variant="h4">Preview de la canción</Typography>
                  {statusInfo && (
                    <Chip label={statusInfo.label} color={statusInfo.color} />
                  )}
                </Stack>
                <Grid container>
                  <Grid item xs={12} lg={6}>
                    <Box sx={{ width: { xs: "100%", lg: "93%" } }}>
                      <img
                        src={mainData.url_img}
                        style={{ borderRadius: "4px/6.7px" }}
                        width="100%"
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <Stack spacing={1}>
                      <Typography variant="h5">
                        {mainData.radarCoin} RC
                      </Typography>
                      <Stack direction="row" flexWrap="wrap">
                        <NombreArtista
                          artista={mainData.artista}
                          fallback={mainData.profile?.nombre_media}
                          sufijo={mainData.nombre}
                        />
                      </Stack>
                      <Typography variant="p">
                        Fecha de envio:{" "}
                        {mainData.fecha
                          ? new Date(mainData.fecha).toLocaleDateString(
                              "es-MX",
                              {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                              }
                            )
                          : "- - -"}
                      </Typography>
                      <Typography variant="p">
                        País: {countries[mainData.profile?.pais]}
                      </Typography>
                      {/* El material de prensa del artista, lo que necesita para
                          escribir la nota. Solo aparece si lo cargó. */}
                      {mainData.presskit && (
                        <Button
                          size="small"
                          href={mainData.presskit}
                          target="_blank"
                          rel="noreferrer"
                          sx={{ px: 0, minWidth: 0, justifyContent: "flex-start" }}
                        >
                          Descargar presskit
                        </Button>
                      )}
                      <Typography variant="p">
                        Género: {mainData.genero}
                      </Typography>
                      <Typography variant="subtitle1">
                        Redes sociales:
                      </Typography>
                      <Stack direction="row" flexWrap="wrap" gap={1}>
                        {socialNetwork.map(({ name, Icon }, i) => (
                          <Button
                            key={i}
                            sx={{
                              py: 1,
                              px: 1,
                              minWidth: "auto",
                              ":hover": {
                                color: "#ffffff",
                                bgcolor: "#F27224",
                              },
                            }}
                            variant="outlined"
                            href={hrefSeguro(mainData.profile?.[name])}
                            target="_blank"
                          >
                            <Icon />
                          </Button>
                        ))}
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>
                <Typography variant="h5">Descripción de la canción</Typography>
                <Typography variant="p">{mainData.descripcion}</Typography>
                <Typography variant="h5">Perfil del artista</Typography>
                <Typography variant="p">
                  {mainData.profile?.descripcion}
                </Typography>
                {/* Si el envío viene de un sello, a quién más representa.
                    Para un artista individual no se dibuja nada. */}
                <RosterPublico
                  userId={mainData.userId}
                  titulo={`Artistas de ${
                    mainData.artista?.via || mainData.profile?.nombre_media || ""
                  }`}
                  compacto
                />
              </Stack>
            </Grid>
            {/* COLUMNA DERECHA */}
            <Grid item xs={12} md={5} lg={5}>
              <Stack spacing={3} px={3}>
                <Stack alignItems="center">
                  <img
                    src={mainData.url_img}
                    style={{ borderRadius: "4px/6.7px" }}
                    width="70%"
                  />
                </Stack>
                {mainData.status === "pending" ? (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    spacing={1}
                  >
                    <LoadingButton
                      loading={loadingApi.includes(
                        `put__productor/envios/${mainData.envioId}`
                      )}
                      onClick={() => updateSend("approve")}
                      color="success"
                    >
                      Aprobar canción
                    </LoadingButton>
                    <LoadingButton
                      loading={loadingApi.includes(
                        `put__productor/envios/${mainData.envioId}`
                      )}
                      onClick={() => updateSend("rejected")}
                      color="error"
                    >
                      Rechazar canción
                    </LoadingButton>
                  </Stack>
                ) : (
                  <Stack spacing={1.5}>
                    <Typography
                      variant="h5"
                      sx={{ paddingBottom: 1, borderBottom: "2px dashed gray" }}
                    >
                      Respuesta del envío
                    </Typography>
                    {statusInfo && (
                      <Stack direction="row">
                        <Chip
                          label={statusInfo.label}
                          color={statusInfo.color}
                          size="small"
                        />
                      </Stack>
                    )}
                    {urlsDelPost(mainData).length > 0 && (
                      <Typography variant="body1" component="div">
                        {urlsDelPost(mainData).length > 1
                          ? "Posts publicados:"
                          : "Post publicado:"}
                        {urlsDelPost(mainData).map((link) => (
                          <div key={link}>
                            <a
                              href={hrefSeguro(link)}
                              target="_blank"
                              rel="noreferrer"
                              style={{ overflowWrap: "anywhere" }}
                            >
                              {link}
                            </a>
                          </div>
                        ))}
                      </Typography>
                    )}
                    {mainData.feedback && (
                      <>
                        <Typography variant="subtitle1">
                          Feedback enviado al artista:
                        </Typography>
                        <Typography variant="body2" color="GrayText">
                          {mainData.feedback}
                        </Typography>
                      </>
                    )}
                    <Button
                      component={RouterLink}
                      to="/productor/historial"
                      variant="text"
                      sx={{ alignSelf: "flex-start", textTransform: "none" }}
                    >
                      Volver al historial
                    </Button>
                  </Stack>
                )}
              </Stack>
            </Grid>
          </Grid>
        </Container>
      )}
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
      <ModalView
        open={openDialog}
        loadingApi={loadingApi}
        setOpen={setOpenDialog}
        loadDecision={loadDecision}
      />
    </>
  );
}
